const routes = [
    //针状焦
    {
        path: 'needle',
        name: '针状焦',
        component: () => import('@/views/needle/index'),
    },
    {
        path: 'needle/twoPage/industry',
        name: '针状焦行业动态二级页',
        component: () => import('@/views/needle/twoPage/industry')
    },
    {
        path: 'needle/industry',
        name: '针状焦行业动态详情页',
        component: () => import('@/views/needle/detail/industry')
    },
    {
        path: 'needle/twoPage/price',
        name: '针状焦价格二级页',
        component: () => import('@/views/needle/twoPage/price')
    },
    {
        path: 'needle/price',
        name: '针状焦价格详情页',
        component: () => import('@/views/needle/detail/price')
    },
    {
        path: 'needle/twoPage/yield',
        name: '针状焦产量二级页',
        component: () => import('@/views/needle/twoPage/yield')
    },
    {
        path: 'needle/yield',
        name: '针状焦产量详情页',
        component: () => import('@/views/needle/detail/yield')
    },
    {
        path: 'needle/yieldXin',
        name: '针状焦产量新闻资讯详情页',
        component: () => import('@/views/needle/detail/yieldXin')
    },
    {
        path: 'needle/twoPage/report',
        name: '针状焦研究报告二级页',
        component: () => import('@/views/needle/twoPage/report')
    },
    {
        path: 'needle/twoPage/stock',
        name: '针状焦库存二级页',
        component: () => import('@/views/needle/twoPage/stock')
    },
    {
        path: 'needle/stock',
        name: '针状焦库存详情页',
        component: () => import('@/views/needle/detail/stock')
    },
    {
        path: 'needle/twoPage/rate',
        name: '针状焦开工率二级页',
        component: () => import('@/views/needle/twoPage/rate')
    },
    {
        path: 'needle/rate',
        name: '针状焦开工率详情页',
        component: () => import('@/views/needle/detail/rate')
    },
    {
        path: 'needle/twoPage/exit',
        name: '针状焦进出口量二级页',
        component: () => import('@/views/needle/twoPage/exit')
    },
    {
        path: 'needle/exit',
        name: '针状焦进出口量详情页',
        component: () => import('@/views/needle/detail/exit')
    },
    {
        path: 'needle/twoPage/downPrice',
        name: '针状焦下游产品价格二级页',
        component: () => import('@/views/needle/twoPage/downPrice')
    },
    {
        path: 'needle/downPrice',
        name: '针状焦下游产品价格详情页',
        component: () => import('@/views/needle/detail/downPrice')
    },
    {
        path: 'needle/twoPage/downRate',
        name: '针状焦下游开工率二级页',
        component: () => import('@/views/needle/twoPage/downRate')
    },
    {
        path: 'needle/downRate',
        name: '针状焦下游开工率详情页',
        component: () => import('@/views/needle/detail/downRate')
    },
    {
        path: 'needle/twoPage/standard',
        name: '针状焦技术及标准二级页',
        component: () => import('@/views/needle/twoPage/standard')
    },
]
export default routes
